import React, {FC} from "react";
import Gimage from "../components/Gimage";
import {Grid} from "@material-ui/core";
import {Work} from "./Works";

export const ClientWorks:Array<Work> = [
    {
        title:"Metamorphosis2023",
        subtitle:"人工生命の制作",
        description:(
            <div>
                <div>
                    Wacom様のコネクテッド・インク東京 2023にて展示されたVRChatワールド、「Metamorphosis2023」にて絵を描画するプロセスから人工生命を生成するアルゴリズム及びそれを用いた演出の制作を担当しました。
                    <div className = "EmbeddingContainer">
                        <blockquote className="twitter-tweet"><p lang="ja" dir="ltr">Wacom Connected Ink 2023<br/>昨年に引き続きVRChatワールド『Metamorphosis』の企画制作をしました。<br/><br/>KISEKI ARTで抽出した創作過程の特徴量を形質とし、仮想の森に生み出される人工生命たち。<br/>新たな姿となった『Metamorphosis』をお楽しみ下さい。<br/>----<br/>Metamorphosis<a href="https://t.co/B0KceYJLxt">https://t.co/B0KceYJLxt</a> <a href="https://t.co/ynjusNfmIY">pic.twitter.com/ynjusNfmIY</a></p>&mdash; Eallin Japan/CGジェネラリストとか募集中 (@eallinjp) <a href="https://twitter.com/eallinjp/status/1725868958958632962?ref_src=twsrc%5Etfw">November 18, 2023</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                    </div>
                </div>
            </div>
        )
    },
    {
        title:"The Dream of a Butterfly",
        subtitle:"デジタルコンテンツのビジュアル開発",
        description:(
            <div>
                <div>
                    渋谷GYREにて展示された　「超複製技術時代の芸術：NFTはアートの何を変えるのか？」にて鎌谷徹太郎氏の「The Dream of a Butterfly」のデジタルコンテンツのビジュアル開発を担当しました。
                    <a href="https://gyre-omotesando.com/artandgallery/nft-art/">https://gyre-omotesando.com/artandgallery/nft-art/</a>
                </div>
            </div>
        )
    },
    {
        title:"Protolive#2 〜ヤマトファンタジア〜",
        subtitle:"一部演出の制作",
        description:(
            <div>
                <div>
                    Cover様の ホロアース にて行われたライブ、Protolive＃2 ヤマトファンタジア にて、一部演出の作成などを担当しました
                    <div className={"EmbeddingContainer"}>
                        <blockquote className="twitter-tweet"><p lang="ja" dir="ltr">Cover様の <a href="https://twitter.com/hashtag/%E3%83%9B%E3%83%AD%E3%82%A2%E3%83%BC%E3%82%B9?src=hash&amp;ref_src=twsrc%5Etfw">#ホロアース</a> にて行われたライブ、Protolive＃2 <a href="https://twitter.com/hashtag/%E3%83%A4%E3%83%9E%E3%83%88%E3%83%95%E3%82%A1%E3%83%B3%E3%82%BF%E3%82%B8%E3%82%A2?src=hash&amp;ref_src=twsrc%5Etfw">#ヤマトファンタジア</a> にて、一部演出の作成などを担当しました！ <a href="https://t.co/8UiZNPNjfM">https://t.co/8UiZNPNjfM</a></p>&mdash; 避雷 (@lucknknock) <a href="https://twitter.com/lucknknock/status/1680159687948521472?ref_src=twsrc%5Etfw">July 15, 2023</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/S1Ya6QYHY0s?si=5KnmYSsDoZhpeysU" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    </div>
                </div>
            </div>
        )
    },
    {
        title:"Boom Boom Back PLAYGROUND remix",
        subtitle:"一部演出の制作",
        description:(
            <div>
                <div>
                    αU Boom Boom Back PLAYGROUND remix にて、一部演出の作成などを担当しました
                    <div className = "EmbeddingContainer">
                        <blockquote className="twitter-tweet" data-media-max-width="560"><p lang="ja" dir="ltr">KDDIの新たなメタバース・Web3サービスプラットフォーム「αU」の設立を記念して、渋谷の街を再現したメタバース空間で360度自由視点のライブが楽しめる「Boom Boom Back PLAYGROUND remix」が公開になります！<a href="https://twitter.com/BEFIRSTofficial?ref_src=twsrc%5Etfw">@BEFIRSTofficial</a> のMV「Boom Boom Back」の世界観をメタバース空間で360度体験できます📱 <a href="https://t.co/JuYuKd8UHO">pic.twitter.com/JuYuKd8UHO</a></p>&mdash; stu inc. (@stuinc_) <a href="https://twitter.com/stuinc_/status/1632957887940292608?ref_src=twsrc%5Etfw">March 7, 2023</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/6LExKs2VtoE?si=N5ZwmINGVYLt1-WA" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    </div>
                </div>
            </div>
        )
    },
]